import PropTypes from 'prop-types';

import LocationOffIcon from '@mui/icons-material/LocationOff';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Grid, Typography } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

const GeolocationFieldComponent = ({ input }) => {
  const { t } = useTransl();
  const isGeoOn = input?.value;
  const color = isGeoOn ? 'primary' : 'error';
  const Icon = isGeoOn ? LocationOnIcon : LocationOffIcon;
  const text = isGeoOn
    ? t('formField.sharingLocation')
    : t('formField.notSharingLocation');
  return (
    <Grid container wrap="nowrap">
      <Icon color={color} />
      <Typography variant="body1" color={color}>
        {text}
      </Typography>
    </Grid>
  );
};

GeolocationFieldComponent.propTypes = {
  input: PropTypes.instanceOf(Object).isRequired,
};

export default GeolocationFieldComponent;
